import { VersionDto } from "@/data/dto/version-dto";
import { URLList } from "@/data/url_list";
import { FetchApiClientMethod } from "@sadtx/fetch-api-client";
import { errorConverter, SATError, SATResult } from "@sadtx/sat-error";

export class VersionSource {
  constructor(private readonly client: FetchApiClientMethod) {}

  async fetchVersion(): Promise<SATResult<VersionDto, SATError>> {
    try {
      const response = await this.client.get(URLList.VERSION.GET_VERSION);
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.error("[VersionSource] :: fetchVersion :: 버전 조회 요청 실패", error);
      const satError = errorConverter.convertError(error);
      return SATResult.failure(satError);
    }
  }
}
